const WORDS = [
  "Mobile Service",
  "We Come to You",
  "Interior + Exterior",
  "Gap, Pennsylvania",
  "Lancaster County",
  "Chester County",
  "Cars — Trucks — SUVs — Vans",
];

const Marquee = () => (
  <div className="overflow-hidden border-b border-white/10 py-5" aria-hidden="true" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
      {[...WORDS, ...WORDS, ...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center gap-10 font-display text-xl font-semibold uppercase tracking-[0.12em] text-slate-600">
          {w}
          <span className="h-1.5 w-1.5 rotate-45 bg-blue-600/70" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
